import { createSlice } from "@reduxjs/toolkit";

const authState = (() => {
  try {
    const raw = localStorage.getItem("melona_auth");
    return raw ? JSON.parse(raw) : { token: null, user: null };
  } catch (_error) {
    return { token: null, user: null };
  }
})();

const authSlice = createSlice({
  name: "auth",
  initialState: authState,
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      localStorage.setItem("melona_auth", JSON.stringify(state));
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      localStorage.removeItem("melona_auth");
    },
  },
});

export const { logout, setCredentials } = authSlice.actions;
export default authSlice.reducer;
